import React from 'react';
import { bool } from 'prop-types';
import { AlertMessage } from './alertMessage';

export const Alerts = (props) => {
  const {
    showAlerts,
    jumpedState,
    impossibleState,
    showSelectionChangeWarning
  } = props;

  if (!showAlerts && !showSelectionChangeWarning) return null;

  return (
    <>
      {showAlerts && jumpedState && (
        <AlertMessage message="Your selections have been updated based on availability." />
      )}
      {showAlerts && impossibleState && (
        <AlertMessage message="We had some trouble loading your options. Select any option to get started." />
      )}
      {!showAlerts && showSelectionChangeWarning && (
        <AlertMessage
          type="info"
          message="We updated your selection based on the available options."
        />
      )}
    </>
  );
};

Alerts.displayName = 'SuperSkuAlerts';

Alerts.propTypes = {
  showAlerts: bool,
  jumpedState: bool,
  impossibleState: bool,
  showSelectionChangeWarning: bool
};

Alerts.defaultProps = {
  showAlerts: false,
  jumpedState: false,
  impossibleState: false,
  showSelectionChangeWarning: false
};
